import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { GrPowerReset } from "react-icons/gr";

import { BUTTON_KEYS, BUTTON_TYPE } from "@/constants/Button";
import { ButtonsPropTypes } from "@/propTypes/Button.type";

const ResetButton = ({ label, buttonProps = {}, onResetSelect }) => {
  const { t } = useTranslation();

  return (
    <Button
      icon={<GrPowerReset />}
      key={BUTTON_KEYS.RESET}
      role="button"
      type={BUTTON_TYPE.DEFAULT}
      onClick={onResetSelect}
      {...buttonProps}
    >
      {label ?? t("global:reset")}
    </Button>
  );
};

ResetButton.propTypes = {
  buttonProps: ButtonsPropTypes,
  label: PropTypes.string,
  onResetSelect: PropTypes.func,
};

export default ResetButton;
